import axios from 'axios';
import { BASE_URL } from '../../../../config/environmentConfig';
import { ON_BOARDING_ROUTES } from '../../../utils/constatns';
import { IAction, IFeeTableData } from '../merchant-interfaces';
import { feeDataTypes } from '../merchant-context-variables';
import { merchantActionTypes } from '../action-types';
import { sendSentryMessage } from '../../../utils/sentry-helper';
import * as React from 'react';

export const fetchConfirmApplicationData = async (dispatch: React.Dispatch<IAction>, id: string): Promise<void> => {
	try {
		axios(`${BASE_URL.MERCHANTS}/${ON_BOARDING_ROUTES.ON_BOARDING}/${id}`)
			.then(res => {
				if (res?.data?.record) {
					const appData = res?.data?.record;
					const feesData: Partial<IFeeTableData> = {};

					appData?.fees?.forEach(el => {
						switch (el?.name) {
							case feeDataTypes.PERCENTAGE:
								feesData.percentage = el.amount / 100;
								break;
							case feeDataTypes.FEE_AMOUNT:
								feesData.feeAmount = el.amount / 100;
								break;
							case feeDataTypes.CHARGEBACK:
								feesData.chargeback = el.amount / 100;
								break;
						}
					});
					dispatch({ type: merchantActionTypes.FETCH_APPLICATION_DATA_SUCCESS, payload: appData });
					dispatch({ type: merchantActionTypes.FETCH_FEES_DATA_SUCCESS, payload: feesData });
				}
			});
	} catch (e) {
		sendSentryMessage({ name: `GET OnBoarding fetch app data error`, context: e });
		dispatch({ type: merchantActionTypes.FETCH_FAIL });
	}
};

export const fetchStatus = async (dispatch: React.Dispatch<IAction>, id: string, token?: string ): Promise<void> => {
	try {
		const headers = token ? { Authorization: `Bearer ${token}` } : {};
		const url = `${BASE_URL.MERCHANTS}/onboarding/${id}/status`;

		const { data } = await axios.get(url, { headers });

		dispatch({ type: merchantActionTypes.FETCH_STATUS_SUCCESS, payload: data?.statusName || null });

	} catch (e) {
		sendSentryMessage({ name: `GET Fetch status/lists error`, context: e });
		dispatch({ type: merchantActionTypes.FETCH_FAIL });
	}
};
